import { Spin } from 'antd';
import styled from 'styled-components';
import { useTheme } from '../utils/global/ThemeContext';

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: ${props => (props.$overlay ? 'rgba(10, 10, 10, 0.7)' : '#0a0a0a')};
`;

const SpinWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  max-width: 500px;
  height: 200px;
  position: fixed;
  top: 35%;

  /* Override Ant Design Spin color to match primary color */
  .ant-spin-dot-item {
    background-color: ${props => props.$primaryColor} !important;
  }

  /* Fix Spin component size */
  .ant-spin {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
  }
`;

const LoadingText = styled.div`
  color: ${props => props.$primaryColor};
  font-size: 14px;
  height: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export default function CenteredLoading({ tip = 'Loading...', overlay = false }) {
  const { theme } = useTheme();
  const primaryColor = theme?.colors?.primary || '#6927f4';

  return (
    <LoadingContainer $overlay={overlay}>
      <SpinWrapper $primaryColor={primaryColor}>
        <Spin size="large" />
        <LoadingText $primaryColor={primaryColor}>{tip}</LoadingText>
      </SpinWrapper>
    </LoadingContainer>
  );
}
